// general
import '../App.css';
import { Link as RouterLink } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive'

// material ui
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';

// custom components
import { CustomColorScheme } from '../components/CustomTheme';
import michaelImage from '../images/michael.jpg';
import audiobooksIcon from '../images/audiobooks.png';
import calendarIcon from '../images/calendar.png';
import recipesIcon from '../images/recipes.png';
import tasklistIcon from '../images/tasklist.png';
import weblistIcon from '../images/weblist.png';


export default function Index(props) {

  const isMobile = useMediaQuery({ query: '(max-width: 750px)' })

  function WebLink(props) {
    const {
      icon,
      title,
      url,
      altUrl
    } = props;
    return (
      <Stack
        direction='row'
        spacing={1}
        alignItems='end'
      >
        <img
          src={icon}
          height={25}
          style={{
            cursor: 'pointer',
          }}
        />
        <Link
          component={RouterLink}
          target='_blank'
          to={url}
          sx={{
            fontSize: 20,
            cursor: 'pointer',
            color: CustomColorScheme['white']
          }}
        >
          {title}
        </Link>
        {
          altUrl &&
          <Link
            component={RouterLink}
            target='_blank'
            to={altUrl}
            sx={{
              fontSize: 16,
              fontStyle: 'italic',
              cursor: 'pointer',
              color: CustomColorScheme['tan'],
              paddingBottom: 0.2,
              paddingLeft: 1,
            }}
          >
            alt
          </Link>

        }
      </Stack>

    )
  }

  return (
    <Stack
      spacing={2}
      sx={{
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <img
        src={michaelImage}
        height={isMobile ? 120 : 200}
        style={{
          margin: 5,
        }}
      />
      <Typography
        sx={{
          fontSize: 22,
          color: CustomColorScheme['white'],
          paddingTop: 1,

        }}
      >
        Web Applications
      </Typography>
      <Stack
        spacing={1}
        sx={{
          color: CustomColorScheme['lightTan'],
          width: 180
        }}
      >
        <WebLink
          icon={audiobooksIcon}
          title='Audiobooks'
          url='https://audiobooks.uptakeblue.com'
          altUrl='https://d32s86y384tmbv.cloudfront.net'
        />
        <WebLink
          icon={calendarIcon}
          title='Calendar'
          url='https://calendar.uptakeblue.com'
          altUrl='https://d2q5b3mk4i12e6.cloudfront.net'
        />
        <WebLink
          icon={recipesIcon}
          title='Recipes'
          url='https://recipes.uptakeblue.com'
          altUrl='https://d2sac5ph2q6h7c.cloudfront.net'
        />
        <WebLink
          icon={tasklistIcon}
          title='Tasklist'
          url='https://tasklist.uptakeblue.com'
          altUrl='https://d32lfe3nm66vvg.cloudfront.net'
        />
        <WebLink
          icon={weblistIcon}
          title='Weblist'
          url='https://weblist.uptakeblue.com'
          altUrl='https://dsf3qwzdv9x4o.cloudfront.net'
        />
      </Stack>
    </Stack>
  )
}